module.exports = __webpack_public_path__ + "img/insight.3a99f4fd.png";